import IdentityTagSelectionSuccessModal from './IdentityTagSelectionSuccessModal';

export default IdentityTagSelectionSuccessModal;
